import { render } from "./암전문프로그램.vue?vue&type=template&id=4ea5c6c2"
import script from "./암전문프로그램.vue?vue&type=script&lang=js"
export * from "./암전문프로그램.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__